export enum TagType {
  Alerts = 'Alerts',
  AccessControl = 'AccessControl',
  AlgorithmMetrics = 'algorithmMetrics',
  ApiKey = 'ApiKey',
  Automation = 'Automation',
  ClauseLibrary = 'ClauseLibrary',
  Clients = 'Clients',
  CompanyHomeSettings = 'CompanyHomeSettings',
  CodeCash = 'CodeCash',
  ConversationalAi = 'ConversationalAi',
  CrmConnections = 'CrmConnections',
  DataFields = 'DataFields',
  DdeTables = 'DdeTables',
  DashboardV2 = 'DashboardV2',
  Department = 'Department',
  Document = 'Document',
  DocumentRestore = 'DocumentRestore',
  Fields = 'Fields',
  Folder = 'Folder',
  Groups = 'Groups',
  Highlight = 'Highlight',
  HomeDocuments = 'HomeDocuments',
  Parties = 'Parties',
  Clauses = 'Clauses',
  Roles = 'Roles',
  SaveSearch = 'SaveSearch',
  SearchV3 = 'SearchV3',
  SharepointConfiguration = 'SharepointConfiguration',
  SharepointOpenDocument = 'SharepointOpenDocument',
  SmartClause = 'SmartClause',
  TableViews = 'TableViews',
  TurnTracking = 'TurnTracking',
  UploadFiles = 'UploadFiles',
  UserPreferences = 'UserPreferences',
  Users = 'Users',
  Webhooks = 'Webhooks',
  Workflows = 'Workflows',
  TicketK2 = 'TicketK2',
  TaskK2 = 'TaskK2',
  TasksK2 = 'TasksK2',
  CommentsK2 = 'CommentsK2',
  CLMeFields = 'CLMeFields',
  CLMeClauses = 'CLMeClauses',
  SigningConfigurationK2 = 'SigningConfigurationK2',
  UnifiedField = 'UnifiedField',
}
